<script setup lang="ts">
import { useChatStore } from '@/stores/chat'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const emit = defineEmits(['close-sidebar'])
const chatStore = useChatStore()
const { conversations, currentConversationId } = storeToRefs(chatStore)

const formattedDate = computed(() => (timestamp: number) => {
  return new Date(timestamp).toLocaleString('zh-CN', {
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
})

function handleConversationClick(id: string) {
  chatStore.setCurrentConversation(id)
  emit('close-sidebar') // 在移动端选择对话后关闭侧边栏
}
</script>

<template>
  <div class="w-full h-full bg-gradient-to-b from-gray-900 to-gray-800 flex flex-col">
    <!-- 头部 -->
    <div class="p-4 flex items-center justify-between">
      <button
        @click="chatStore.createNewConversation"
        class="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg py-3 px-4 hover:from-blue-600 hover:to-blue-700 transition-all duration-200 transform active:scale-95 flex items-center justify-center space-x-2 shadow-lg"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
        </svg>
        <span>新建聊天</span>
      </button>
      
      <button 
        class="ml-2 p-2 text-gray-400 hover:text-white lg:hidden transition-colors"
        @click="$emit('close-sidebar')"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- 聊天列表 -->
    <div class="flex-1 overflow-y-auto">
      <div
        v-for="conversation in conversations"
        :key="conversation.id"
        @click="handleConversationClick(conversation.id)"
        class="group"
      >
        <div
          :class="[
            'p-4 cursor-pointer transition-all duration-200 hover:bg-gray-800/50 border-l-4',
            conversation.id === currentConversationId
              ? 'bg-gray-800/50 border-blue-500 shadow-md'
              : 'bg-transparent border-transparent'
          ]"
        >
          <div class="text-white truncate font-medium group-hover:text-blue-400 transition-colors flex items-center gap-2">
            <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
            </svg>
            {{ conversation.title || '新对话' }}
          </div>
          <div class="text-gray-400 text-sm mt-1 pl-6">
            {{ formattedDate(conversation.createdAt) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 